package info.rezident.app.data

import info.rezident.app.pages.QuizViewModel
import info.rezident.app.pages.profile.ProfileViewModel

object DependencyInjection {
    val quizViewModel by lazy { QuizViewModel() }
    val profileViewModel by lazy { ProfileViewModel() }
}